import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  enableProdMode,
  ErrorHandler,
  provideAppInitializer,
  inject,
  importProvidersFrom,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AngularSplitModule } from 'angular-split';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CookieService, CookieModule } from 'ngx-cookie';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { AppRoutingModule } from './app/app-routing.module';
import { HomeComponent } from './app/pages/home/home.component';
import { ColumnFilterPipe } from './app/pipes/column-filter.pipe';
import { ConcactStringValues } from './app/pipes/concat-string-values.pipe';
import { ApiInterceptorProvider } from './app/services/apiInterceptor/api.interceptor';
import { AppInitializerService } from './app/services/app-initializer/app-initializer.service';
import { ErrorHandlerService } from './app/services/errorHandler/error-handler.service';
import { GenerateBoDocumentsService } from './app/services/generate-bo-document/generate-bo-documents.service';
import { longRequestInterceptor } from './app/services/longRequestInterceptor/long-request.interceptor';
import { ModalDialogService } from './app/services/modalDialog/modal-dialog.service';
import { SseService } from './app/services/sse/sse.service';
import { retryOnTimeoutInterceptor } from './app/services/timeoutRetryInterceptor/retry.interceptor';
import { ToastNotificationsManagerService } from './app/services/toast-notifications-manager/toast-notifications-manager.service';
import { environment } from './environments/environment';

if (environment.production) enableProdMode();

bootstrapApplication(HomeComponent, {
  providers: [
    importProvidersFrom(
      ModalModule.forRoot(),
      FormsModule,
      ReactiveFormsModule,
      AppRoutingModule,
      NgxDatatableModule,
      AngularSplitModule,
      PdfViewerModule,
      NgxExtendedPdfViewerModule,
      JwtModule.forRoot({
        config: {
          tokenGetter: () => localStorage.getItem('access_token'),
        },
      }),
      CookieModule.withOptions(),
      NgxChartsModule,
      BsDropdownModule.forRoot(),
      BsDatepickerModule.forRoot(),
      TooltipModule.forRoot(),
    ),
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService,
    },
    ApiInterceptorProvider,
    ColumnFilterPipe,
    ModalDialogService,
    SseService,
    provideAppInitializer(() => inject(AppInitializerService).init()),
    ConcactStringValues,
    GenerateBoDocumentsService,
    CookieService,
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([longRequestInterceptor, retryOnTimeoutInterceptor]),
    ),
    ToastNotificationsManagerService,
    provideAnimations(),
  ],
}).catch(err => console.error(err));
